export function checkOverflow(DOMElement) {
    const isOverflowingX = DOMElement.scrollWidth > DOMElement.offsetWidth;
    const isOverflowingY = DOMElement.scrollHeight > DOMElement.offsetHeight;
    return isOverflowingX || isOverflowingY;
}

export function selectContent(el) {
    const range = document.createRange();
    range.selectNodeContents(el);

    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
}

export function isElementPartOfInteractive(el) {
    if (el.tagName === "BUTTON" && !el.getAttribute("disabled")) return true;
    if (el.parentNode) return isElementPartOfInteractive(el.parentNode);
    return false;
}